import React from "react";
import classes from "./GameOverModal.module.css";
import { useNavigate } from "react-router-dom";
import { resetIndex } from "../slices/activeTileSlice";
import { resetEnteredWords } from "../slices/enteredWordSlice";
import { resetTargetWord } from "../slices/targetWordSlice";
import { resetTargetWord3 } from "../slices/targetWord3Slice";
import { resetWord3Result } from "../slices/word3Result";
import { resetWordResult } from "../slices/wordResult";
import { resetTiles } from "../slices/tileWordSlice";
import { useDispatch } from "react-redux";
import { ResetTime, ResetTimeForProgress } from "../slices/timeSlice";

const GameOverModal = ({ closeModalHandler, winType, originalWord }) => {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const goBack=()=>{
    dispatch(resetIndex());
    dispatch(resetTiles());
    dispatch(resetEnteredWords());
    dispatch(resetTargetWord());
    dispatch(resetTargetWord3());
    dispatch(resetWord3Result());
    dispatch(resetWordResult());
    dispatch(ResetTime());
    dispatch(ResetTimeForProgress());
    navigate('/home');
  }
  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>
        {winType == 1 && (
          <>
            <div className={classes.modal_img_container}>
              <img
                className={classes.modal_img}
                src="/assets/images/happy.png"
                alt="result"
              />
            </div>
            <div className={classes.modal_description}>
              <h1>Congratulations...</h1>
              <p>You guessed right!</p>
              <p>The word was {originalWord}</p>
            </div>
          </>
        )}
        {winType == 0 && (
          <>
            <div className={classes.modal_img_container}>
              <img
                className={classes.modal_img}
                src="/assets/images/game_over.png"
                alt="result"
              />
            </div>
            <div className={classes.modal_description}>
              <h1>OOPS...</h1>
              <p>You guessed wrong!</p>
              <p>The word was {originalWord}</p>
            </div>
          </>
        )}

        <div className={classes.buttons_container}>
          <button
            type="button"
            className={classes.play_btn}
            onClick={closeModalHandler}
          >
            Play Again!
          </button>
          <button
            type="button"
            className={classes.back_btn}
            onClick={goBack}
          >
            Go Back!
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverModal;
